import { KatPopover } from "@amzn/katal-react";
import classnames from "classnames";
import React, { type FC } from "react";
import { type WithTranslation, withTranslation } from "react-i18next";
import styles from "src/styles.module.scss";

const Avatar: FC<{ userAlias?: string } & WithTranslation> = ({
  userAlias,
  t,
}) => {
  return userAlias ? (
    <div
      className={classnames(
        styles.justify_end,
        styles.flex,
        styles.align_items_center
      )}
    >
      <div className={classnames(styles.justify_end, styles.flex)}>
        <KatPopover triggerType={"hover"} position={"bottom-end"}>
          <img
            slot={"trigger"}
            alt={t("aic_avatar_authenticated_user")}
            src={`https://badgephotos.corp.amazon.com/?login=${userAlias}`}
            className={classnames(
              styles.b_2_solid,
              styles.b_radius_50,
              styles.w_fixed_35,
              styles.h_fixed_35,
              styles.obj_fit_cover
            )}
          />
          <div
            className={classnames(
              styles.ml_16,
              styles.flex,
              styles.align_items_center,
              styles.justify_center
            )}
          >
            <h5 className={styles.mb_zero_important}>
              {t("aic_avatar_user_welcome")}
              <span className={styles.capitalizedText}>{userAlias}!</span>
            </h5>
          </div>
        </KatPopover>
      </div>
    </div>
  ) : (
    <span />
  );
};

export default withTranslation()(Avatar);
